import { combineReducers } from 'redux';
import modules from './module.reducer';

const moduleAppReducer = combineReducers({
    modules,
});

export default moduleAppReducer;


// WEBPACK FOOTER //
// src/main/content/module/store/reducers/index.js